import "../../nzComponent.css";
const NZYouTube = () => {
  return (
    <div className="bg-[#f1f1f1]">
      <div className="pt-[86px] pb-[65px] bg-[#f1f1f1] nz-you-tube-bg">
        <div className="md:max-w-[80%] max-w-full mx-auto py-[30px]">
          <div className="custom-container px-[30px] text-center">
            <div className="kuunari-bold 2xl:text-[70px] lg:text-[66px] md:text-[55px] text-[55px] font-semibold	lg:mb-[60px] sm:mb-[20px] text-[#383838] leading-[1em] mb-[10px]">
              “New Zealand’s Best  ATV”
            </div>

            <div className="text-center flex items-center justify-center max-w-[821px] mx-auto">
              <iframe
                width="70%100%"
                height="447px"
                src="https://www.youtube.com/embed/OAkhAEYyw5g?si=ygwxx6qAodMlxfhh"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>

            <p className="text-center text-[#A8A6A6] text-[20px] leading-[26px] montserrat-medium pt-[30px] pb-[30px]">
              Geoff Hill from Tuatara ATV explains the unique features of the eTuatara for first time operators.
            </p>
            <p className="text-center text-[#383838] text-[30px] leading-[68px] pt-[3px] pb-[13px] kuunari-bold uppercase">
              ATV? UTV? Side-by-side? What’s the difference?
            </p>
            <div className="pt-[5px] pb-[8px]">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-4">
                <div className="col-span-1">
                  <p className="text-center text-[#383838] text-[24px] pt-[3px] pb-[13px] kuunari-bold">
                    ATVs (All-Terrain Vehicles):
                  </p>
                  <p className="text-[16px] leading-[24px] text-[#A8A6A6] max-w-[483px] mx-auto">
                    Also known as quad bikes or four-wheelers, typically designed for a single rider who straddles the
                    seat, usually controlled with handlebars, like a motorcycle. Generally smaller and more manoeuvrable
                    than side-by-sides.  ATVs are  commonly used in farming, particularly for tasks like mustering livestock. They are subject to
                    specific safety regulations in New Zealand due to high accident rates.
                  </p>
                </div>
                <div className="col-span-1">
                  <p className="text-center text-[#383838] text-[24px] pt-[3px] pb-[13px] kuunari-bold ">
                    UTVs (Off-Road Utility Vehicle):
                  </p>
                  <p className="text-[16px] leading-[24px] text-[#A8A6A6] max-w-[483px] mx-auto">
                    A UTV is  a member of the side-by-side stable of vehicles, which have a side-by-side seating configuration and have a steering wheel and foot pedals, more like a car.  They are generally equipped with a larger cargo bed for hauling materials and have the ability to carry up to three passengers including the driver.  UTVs and side-by-sides are generally considered safer than ATVs due to their ROPS (roll over protection system) and seat belts.  They are principally used in agriculture, while UTVs have a much wider application.
                  </p>
                </div>
              </div>
              {/* <p className="text-[16px] text-[#A8A6A6] mt-[24px]  mb-[14px] montserrat-medium">
                So, what’s the Tuatara? It’s all three: a side-by-side, ATV and a UTV.
                <br />
                <strong className="text-[#383838]">The UTV that’s got it all!</strong>
              </p> */}
              {/* <p className="text-[16px] text-[#383838] mt-[24px]  mb-[14px]  montserrat-medium">
                Read more on the <span className="text-[#AF8600]">NZTA website.</span>
              </p> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NZYouTube;
